module.exports = __webpack_public_path__ + "img/media-stream.6d23f2fc.png";